import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const InterfaceDesign = () =>  {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">02</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Mobile AI Feature Roadmapping</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Selecting which generative features to build requires a careful balance between user value and hardware capabilities. We define custom AI product roadmaps tailored to your mobile applications.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        By mapping user friction points to machine learning capabilities, we help product leads design features such as predictive inputs, smart notifications, local search indexing, and real-time audio transcripts that feel natural.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-8 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <h4 className="text-sm font-semibold mb-6 text-zinc-900 dark:text-white flex items-center space-x-2">
                            <span>Mobile AI Feature Checklist</span>
                        </h4>
                        <div className="space-y-4 font-sans text-xs">
                            <div className="flex items-center space-x-3 text-zinc-700 dark:text-zinc-300">
                                <span className="p-1 rounded bg-purple-100 dark:bg-purple-500/10 text-purple-700 dark:text-purple-400 font-mono font-medium">PHASE 1</span>
                                <span>Real-Time Voice Transcripts & Translation</span>
                            </div>
                            <div className="flex items-center space-x-3 text-zinc-700 dark:text-zinc-300">
                                <span className="p-1 rounded bg-purple-100 dark:bg-purple-500/10 text-purple-700 dark:text-purple-400 font-mono font-medium">PHASE 2</span>
                                <span>Local Vector Database Semantic Retrieval</span>
                            </div>
                            <div className="flex items-center space-x-3 text-zinc-700 dark:text-zinc-300">
                                <span className="p-1 rounded bg-purple-100 dark:bg-purple-500/10 text-purple-700 dark:text-purple-400 font-mono font-medium">PHASE 3</span>
                                <span>Predictive Content Generation & Auto-Funnels</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default InterfaceDesign